import React from "react";
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/src/owl.carousel.css';
import 'react-owl-carousel2/src/owl.theme.default.css';
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './reviewsWidget.module.css';

let background1 = require('../images/profile-1.png').default;

let owlClass = "listing-owl listing-owl--shadow " + styles.listingWrap;

const options = {
    items: 3,
    nav: false,
    dots: false,
    rewind: false,
    autoplay: false,
    margin: 14,
    responsive : {
        0 : {
            items: 1,
            stagePadding: 30
        },
        900 : {
            items: 3,
            stagePadding: 35
        }
    }
};


function ReviewsWidget(props) {
    
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    return (
        <div className={styles.sectionReviewsWidget} style={{ backgroundColor: `${bgColor}`}}>
            <div className={styles.sectionContent}>
                <div class="container mx-auto">
                    <h3>{props.heading}</h3>
                    
                    <div className={owlClass}>
                    
                        <OwlCarousel options={options}>

                            <div className={styles.listingItem}>
                                <div className={styles.itemHead}>
                                    <div className={styles.itemImage}>
                                        <div className={styles.itemImageBackground} style={{ backgroundImage: `url(${background1})` }}></div>
                                    </div>
                                    <div className={styles.itemRatingWrap}>
                                        <h4>Roland Youakim</h4>
                                        <div className={styles.itemRating}>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.itemDetails}>
                                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum</p>
                                </div>
                            </div>

                            <div className={styles.listingItem}>
                                <div className={styles.itemHead}>
                                    <div className={styles.itemImage}>
                                        <div className={styles.itemImageBackground} style={{ backgroundImage: `url(${background1})` }}></div>
                                    </div>
                                    <div className={styles.itemRatingWrap}>
                                        <h4>Roland Youakim</h4>
                                        <div className={styles.itemRating}>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.itemDetails}>
                                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum</p>
                                </div>
                            </div>

                            <div className={styles.listingItem}>
                                <div className={styles.itemHead}>
                                    <div className={styles.itemImage}>
                                        <div className={styles.itemImageBackground} style={{ backgroundImage: `url(${background1})` }}></div>
                                    </div>
                                    <div className={styles.itemRatingWrap}>
                                        <h4>Roland Youakim</h4>
                                        <div className={styles.itemRating}>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.itemDetails}>
                                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum</p>
                                </div>
                            </div>

                            <div className={styles.listingItem}>
                                <div className={styles.itemHead}>
                                    <div className={styles.itemImage}>
                                        <div className={styles.itemImageBackground} style={{ backgroundImage: `url(${background1})` }}></div>
                                    </div>
                                    <div className={styles.itemRatingWrap}>
                                        <h4>Roland Youakim</h4>
                                        <div className={styles.itemRating}>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.itemDetails}>
                                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum</p>
                                </div>
                            </div>

                        </OwlCarousel>

                    </div>

                </div>
            </div>
        </div>
    );
}
  
export default ReviewsWidget;